const css = require('./user-form.css');
const Error = require('../../../auth/error');
const UserSharedDataForm = require('../user-shared-data-form');
const IndividualForm = require('../individual-form');
const LegalEntityForm = require('../legal-entity-form');
const SoleProprietorForm = require('../sole-proprietor-form');
const ActionsPanel = require('./actions-panel');
const signals = require('../../../../signals/account/user-form');

class UserForm {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, this.$context.props, { css }));
    }
}

module.exports = {
    constructor: UserForm,
    children: [
        {
            name: 'error',
            component: Error,
            props: {
                text: 'Что-то пошло не так. Пожалуйста, нажмите кнопку еще раз.'
            },
            watcher: {
                isError: ['account', 'userForm', 'isError']
            }
        },
        {
            name: 'user-shared-data-form',
            component: UserSharedDataForm(['account', 'userForm'], signals.selectUserType, signals.selectCountry),
            props: {
                formPath: 'account.userForm',
                disableEmail: true
            },
            parentPropsMap: {
                'disableEditing': 'disableEditing'
            },
            watcher: {
                isUserTypeSelectEnabled: ['account', 'userForm', 'computed', 'isUserTypeSelectEnabled']
            }
        },
        {
            name: 'legal-entity-form',
            component: LegalEntityForm(['account', 'userForm']),
            props: {
                formPath: 'account.userForm'
            },
            parentPropsMap: {
                'disableEditing': 'disableEditing'
            },
            watcher: {
                userCountryId: ['account', 'userForm', 'form', 'countryId']
            }
        },
        {
            name: 'sole-proprietor-form',
            component: SoleProprietorForm(['account', 'userForm']),
            props: {
                formPath: 'account.userForm'
            },
            parentPropsMap: {
                'disableEditing': 'disableEditing'
            },
            watcher: {
                userCountryId: ['account', 'userForm', 'form', 'countryId']
            }
        },
        {
            name: 'individual-form',
            component: IndividualForm(['account', 'userForm']),
            props: {
                formPath: 'account.userForm'
            },
            parentPropsMap: {
                'disableEditing': 'disableEditing'
            },
            watcher: {
                userCountryId: ['account', 'userForm', 'form', 'countryId']
            }
        },
        {
            name: 'actions-panel',
            component: ActionsPanel,
            watcher: {
                isSaveEnabled: ['account', 'userForm', 'computed', 'saveButton', 'isEnabled'],
                isCancelEnabled: ['account', 'userForm', 'computed', 'cancelButton', 'isEnabled']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/common/user/user-form/index.js